angular.module('app').config(inventoryRouting);

function inventoryRouting($routeProvider) {
  $routeProvider.when('/inventory', {
    pageTitle: 'INVENTORY',
    template: '<inventory-list></inventory-list>',
    menu: 'inventory',
    accessPermission: [
      'index_tourinventory_accountadmin',
      'index_transportationinventory_accountadmin',
      'index_hotelinventory_accountadmin',
    ],
    authReq: true,
  });
}

inventoryRouting.$inject = ['$routeProvider'];
